export default function getYoutubeId(url: string): string | null {
  const urlAfterSplit = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  return undefined !== urlAfterSplit[2] ? urlAfterSplit[2].split(/[^0-9a-z_-]/i)[0] : null;
}
